import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_chest_proto from './dcei_wildsky_chest_proto';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class DailyTrialData_Level {
  get descriptor() {
    return DailyTrialData_Level.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasRewardKey = false;
    this._rewardKey = null;
    this._hasChestKey = false;
    this._chestKey = null;
    this._bundleIds = [];
    this._hasCardName = false;
    this._cardName = null;
    this._levelTips = [];
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasRewardKey) return false;
    if (this._hasChestKey) return false;
    if (this._bundleIds.length > 0) return false;
    if (this._hasCardName) return false;
    if (this._levelTips.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialData_Level) {
      return value;
    }
    return DailyTrialData_Level.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialData_Level();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.rewardKey != null) {
      result._hasRewardKey = true;
      result._rewardKey = JsonToString.fromJson(json.rewardKey);
    }
    if (json.chestKey != null) {
      result._hasChestKey = true;
      result._chestKey = JsonToString.fromJson(json.chestKey);
    }
    result._bundleIds = JsonToList(json.bundleIds, JsonToString);
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    result._levelTips = JsonToList(json.levelTips, JsonToString);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasRewardKey) {
      result.rewardKey = JsonToString.toJson(this._rewardKey);
    }
    if (this._hasChestKey) {
      result.chestKey = JsonToString.toJson(this._chestKey);
    }
    if (this._bundleIds.length > 0) {
      result.bundleIds = ArrayToJson(this._bundleIds, JsonToString);
    }
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    if (this._levelTips.length > 0) {
      result.levelTips = ArrayToJson(this._levelTips, JsonToString);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {string}
   */
  get rewardKey() {
    return this._hasRewardKey ? this._rewardKey : JsonToString.default;
  }
  get hasRewardKey() {
    return this._hasRewardKey;
  }
  setRewardKey(path, value) {
    return {type: 'SET', path: path.concat(['rewardKey']), value};
  }
  deleteRewardKey(path) {
    return {type: 'DELETE', path: path.concat(['rewardKey'])};
  }
  /**
   * @returns {string}
   */
  get chestKey() {
    return this._hasChestKey ? this._chestKey : JsonToString.default;
  }
  get hasChestKey() {
    return this._hasChestKey;
  }
  setChestKey(path, value) {
    return {type: 'SET', path: path.concat(['chestKey']), value};
  }
  deleteChestKey(path) {
    return {type: 'DELETE', path: path.concat(['chestKey'])};
  }
  /**
   * @returns {string[]}
   */
  get bundleIds() {
    return this._bundleIds;
  }
  addBundleIds(path, value) {
    return {type: 'ADD', path: path.concat(['bundleIds']), value};
  }
  setBundleIds(path, value) {
    return {type: 'SET', path: path.concat(['bundleIds']), value: ArrayToJson(value, JsonToString)};
  }
  setBundleIdsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['bundleIds', key]), value};
  }
  deleteBundleIds(path) {
    return {type: 'DELETE', path: path.concat(['bundleIds'])};
  }
  deleteBundleIdsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['bundleIds', key])};
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  /**
   * @returns {string[]}
   */
  get levelTips() {
    return this._levelTips;
  }
  addLevelTips(path, value) {
    return {type: 'ADD', path: path.concat(['levelTips']), value};
  }
  setLevelTips(path, value) {
    return {type: 'SET', path: path.concat(['levelTips']), value: ArrayToJson(value, JsonToString)};
  }
  setLevelTipsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levelTips', key]), value};
  }
  deleteLevelTips(path) {
    return {type: 'DELETE', path: path.concat(['levelTips'])};
  }
  deleteLevelTipsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levelTips', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new DailyTrialData_Level(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewardKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._hasRewardKey = true;
              copy._rewardKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRewardKey) {
                return this;
              }
              const copy = new DailyTrialData_Level(this);
              copy._hasRewardKey = false;
              copy._rewardKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chestKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._hasChestKey = true;
              copy._chestKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestKey) {
                return this;
              }
              const copy = new DailyTrialData_Level(this);
              copy._hasChestKey = false;
              copy._chestKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "bundleIds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._bundleIds = [];        for (let i of value) {
                copy._bundleIds.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialData_Level(this);
              copy._bundleIds = copy._bundleIds.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._bundleIds.length === 0) {
                return this;
              }
              const copy = new DailyTrialData_Level(this);
              copy._bundleIds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._bundleIds = copy._bundleIds.slice();
              copy._bundleIds[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialData_Level(this);
              copy._bundleIds = copy._bundleIds.slice(0, path[1]).concat(copy._bundleIds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._bundleIds.length) {
            return this;
          }
          const oldValue = this._bundleIds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialData_Level(this);
          copy._bundleIds = copy._bundleIds.slice();
          copy._bundleIds[key] = newValue;
          return copy;
        }
      }
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new DailyTrialData_Level(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelTips": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._levelTips = [];        for (let i of value) {
                copy._levelTips.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialData_Level(this);
              copy._levelTips = copy._levelTips.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levelTips.length === 0) {
                return this;
              }
              const copy = new DailyTrialData_Level(this);
              copy._levelTips = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levelTips.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_Level(this);
              copy._levelTips = copy._levelTips.slice();
              copy._levelTips[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialData_Level(this);
              copy._levelTips = copy._levelTips.slice(0, path[1]).concat(copy._levelTips.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levelTips.length) {
            return this;
          }
          const oldValue = this._levelTips[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialData_Level(this);
          copy._levelTips = copy._levelTips.slice();
          copy._levelTips[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialData_Level} other
   * @returns {DailyTrialData_Level}
   */
  merge(other) {
    const copy = new DailyTrialData_Level(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasRewardKey) {
      copy._hasRewardKey = true;
      copy._rewardKey = other._rewardKey;
    }
    if (other._hasChestKey) {
      copy._hasChestKey = true;
      copy._chestKey = other._chestKey;
    }
    copy._bundleIds = this._bundleIds.concat(other._bundleIds);
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    copy._levelTips = this._levelTips.concat(other._levelTips);
    return copy;
  }
}
DailyTrialData_Level.default = new DailyTrialData_Level();
class DailyTrialData_Level_Builder {
  constructor(value) {
    this._value = new DailyTrialData_Level(value);
  }
  build() {
    return new DailyTrialData_Level(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setRewardKey(value) {
    this._value._hasRewardKey = true;
    this._value._rewardKey = value;
    return this;
  }
  deleteRewardKey() {
    this._value._hasRewardKey = false;
    this._value._rewardKey = null;
    return this;
  }
  setChestKey(value) {
    this._value._hasChestKey = true;
    this._value._chestKey = value;
    return this;
  }
  deleteChestKey() {
    this._value._hasChestKey = false;
    this._value._chestKey = null;
    return this;
  }
  addAllBundleIds(values) {
    this._value._bundleIds = this._value._bundleIds.concat(values);
    return this;
  }
  addBundleIds(value) {
    this._value._bundleIds = this._value._bundleIds.concat([value]);
    return this;
  }
  setBundleIds(index, value) {
    this._value._bundleIds = this._value._bundleIds.concat();
    this._value._bundleIds[index] = value;
    return this;
  }
  clearBundleIds() {
    this._value._bundleIds = [];
    return this;
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
  addAllLevelTips(values) {
    this._value._levelTips = this._value._levelTips.concat(values);
    return this;
  }
  addLevelTips(value) {
    this._value._levelTips = this._value._levelTips.concat([value]);
    return this;
  }
  setLevelTips(index, value) {
    this._value._levelTips = this._value._levelTips.concat();
    this._value._levelTips[index] = value;
    return this;
  }
  clearLevelTips() {
    this._value._levelTips = [];
    return this;
  }
}
DailyTrialData_Level.Builder = DailyTrialData_Level_Builder;
class DailyTrialData_Level_WithParent {
  /**
   * @param {DailyTrialData_Level} value
   * @param {DailyTrialData_Level_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialData_Level.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasRewardKey() {
    if (this._cachedHasRewardKey === undefined) {
      if (this._value.hasRewardKey) {
        this._cachedHasRewardKey = true;
      } else {
        this._cachedHasRewardKey = this._parent ? this._parent.hasRewardKey : false;
      }
    }
    return this._cachedHasRewardKey;
  }
  get rewardKey() {
    if (this._cachedRewardKey === undefined) {
      if (this._value.hasRewardKey) {
        this._cachedRewardKey = this._value.rewardKey;
      } else {
        this._cachedRewardKey = this._parent ? this._parent.rewardKey : this._value.rewardKey;
      }
    }
    return this._cachedRewardKey;
  }
  get hasChestKey() {
    if (this._cachedHasChestKey === undefined) {
      if (this._value.hasChestKey) {
        this._cachedHasChestKey = true;
      } else {
        this._cachedHasChestKey = this._parent ? this._parent.hasChestKey : false;
      }
    }
    return this._cachedHasChestKey;
  }
  get chestKey() {
    if (this._cachedChestKey === undefined) {
      if (this._value.hasChestKey) {
        this._cachedChestKey = this._value.chestKey;
      } else {
        this._cachedChestKey = this._parent ? this._parent.chestKey : this._value.chestKey;
      }
    }
    return this._cachedChestKey;
  }
  get selfBundleIds() {
    return this._value.bundleIds;
  }
  get inherentBundleIds() {
    if (!this._inherentBundleIds) {
      this._inherentBundleIds = this._parent ? this._parent.bundleIds : [];
    }
    return this._inherentBundleIds;
  }
  get bundleIds() {
    if (!this._allBundleIds) {
      this._allBundleIds = this._parent ? this._parent.bundleIds.concat(this.selfBundleIds) : this.selfBundleIds;
    }
    return this._allBundleIds;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  get selfLevelTips() {
    return this._value.levelTips;
  }
  get inherentLevelTips() {
    if (!this._inherentLevelTips) {
      this._inherentLevelTips = this._parent ? this._parent.levelTips : [];
    }
    return this._inherentLevelTips;
  }
  get levelTips() {
    if (!this._allLevelTips) {
      this._allLevelTips = this._parent ? this._parent.levelTips.concat(this.selfLevelTips) : this.selfLevelTips;
    }
    return this._allLevelTips;
  }
  update(current, parent) {
    const result = new DailyTrialData_Level_WithParent(current, parent);
    return result;
  }
}
DailyTrialData_Level_WithParent.default = new DailyTrialData_Level_WithParent(DailyTrialData_Level.default, null);
DailyTrialData_Level.WithParent = DailyTrialData_Level_WithParent;
class DailyTrialData_Level_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 1,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get rewardKey() {
    if (!this._rewardKey) {
      this._rewardKey = {
        name: "rewardKey",
        Name: "RewardKey",
        number: 2,
        protoType: 9,
        protoName: "reward_key",
        type: JsonToString,
        options: {
          valueDropdown: "DailyTrialRewardKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewardKey;
  }
  get chestKey() {
    if (!this._chestKey) {
      this._chestKey = {
        name: "chestKey",
        Name: "ChestKey",
        number: 3,
        protoType: 9,
        protoName: "chest_key",
        type: JsonToString,
        options: {
          valueDropdown: "DailyTrialChestKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestKey;
  }
  get bundleIds() {
    if (!this._bundleIds) {
      this._bundleIds = {
        name: "bundleIds",
        Name: "BundleIds",
        number: 4,
        protoType: 9,
        protoName: "bundle_ids",
        type: JsonToString,
        isRepeated: true,
        options: {
          valueDropdown: "DailyTrialBundleIdList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._bundleIds;
  }
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 5,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
          valueDropdown: "CardNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get levelTips() {
    if (!this._levelTips) {
      this._levelTips = {
        name: "levelTips",
        Name: "LevelTips",
        number: 6,
        protoType: 9,
        protoName: "level_tips",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelTips;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.rewardKey,
        this.chestKey,
        this.bundleIds,
        this.cardName,
        this.levelTips,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRewardKey",
        Name: "DummyOneofForRewardKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestKey",
        Name: "DummyOneofForChestKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialData_Level.descriptor = new DailyTrialData_Level_Descriptor();
class DailyTrialData_DailyTrialReward {
  get descriptor() {
    return DailyTrialData_DailyTrialReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._items = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._items.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialData_DailyTrialReward) {
      return value;
    }
    return DailyTrialData_DailyTrialReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialData_DailyTrialReward();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._items = JsonToList(json.items, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._items.length > 0) {
      result.items = ArrayToJson(this._items, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get items() {
    return this._items;
  }
  addItems(path, value) {
    return {type: 'ADD', path: path.concat(['items']), value: value.toJson()};
  }
  setItems(path, value) {
    return {type: 'SET', path: path.concat(['items']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setItemsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['items', key]), value: value.toJson()};
  }
  deleteItems(path) {
    return {type: 'DELETE', path: path.concat(['items'])};
  }
  deleteItemsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['items', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "items": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._items = [];        for (let i of value) {
                copy._items.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._items = copy._items.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._items.length === 0) {
                return this;
              }
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._items = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._items = copy._items.slice();
              copy._items[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialData_DailyTrialReward(this);
              copy._items = copy._items.slice(0, path[1]).concat(copy._items.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._items.length) {
            return this;
          }
          const oldValue = this._items[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialData_DailyTrialReward(this);
          copy._items = copy._items.slice();
          copy._items[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialData_DailyTrialReward} other
   * @returns {DailyTrialData_DailyTrialReward}
   */
  merge(other) {
    const copy = new DailyTrialData_DailyTrialReward(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._items = this._items.concat(other._items);
    return copy;
  }
}
DailyTrialData_DailyTrialReward.default = new DailyTrialData_DailyTrialReward();
class DailyTrialData_DailyTrialReward_Builder {
  constructor(value) {
    this._value = new DailyTrialData_DailyTrialReward(value);
  }
  build() {
    return new DailyTrialData_DailyTrialReward(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllItems(values) {
    this._value._items = this._value._items.concat(values);
    return this;
  }
  addItems(value) {
    this._value._items = this._value._items.concat([value]);
    return this;
  }
  setItems(index, value) {
    this._value._items = this._value._items.concat();
    this._value._items[index] = value;
    return this;
  }
  clearItems() {
    this._value._items = [];
    return this;
  }
}
DailyTrialData_DailyTrialReward.Builder = DailyTrialData_DailyTrialReward_Builder;
class DailyTrialData_DailyTrialReward_WithParent {
  /**
   * @param {DailyTrialData_DailyTrialReward} value
   * @param {DailyTrialData_DailyTrialReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialData_DailyTrialReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfItems() {
    if (!this._selfItems) {
      this._selfItems = [];
      for (let i of this._value.items) {
        this._selfItems.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfItems;
  }
  get inherentItems() {
    if (!this._inherentItems) {
      this._inherentItems = this._parent ? this._parent.items : [];
    }
    return this._inherentItems;
  }
  get items() {
    if (!this._allItems) {
      this._allItems = this._parent ? this._parent.items.concat(this.selfItems) : this.selfItems;
    }
    return this._allItems;
  }
  update(current, parent) {
    const result = new DailyTrialData_DailyTrialReward_WithParent(current, parent);
    if (this._selfItems) {
      if (this._value.items === current.items) {
        result._selfItems = this._selfItems;
      } else {
        result._selfItems = [];
        for (let i = 0; i < current.items.length; i++) {
          const oldValue = this._value.items[i];
          if (oldValue) {
            const oldCache = this._selfItems[i];
            if (oldValue === current.items[i]) {
              result._selfItems[i] = oldCache;
            } else {
              result._selfItems[i] = oldCache.update(current.items[i], null);
            }
          } else {
            result._selfItems[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.items[i], null);
          }
        }
      }
    }
    return result;
  }
}
DailyTrialData_DailyTrialReward_WithParent.default = new DailyTrialData_DailyTrialReward_WithParent(DailyTrialData_DailyTrialReward.default, null);
DailyTrialData_DailyTrialReward.WithParent = DailyTrialData_DailyTrialReward_WithParent;
class DailyTrialData_DailyTrialReward_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get items() {
    if (!this._items) {
      this._items = {
        name: "items",
        Name: "Items",
        number: 2,
        protoType: 11,
        protoName: "items",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._items;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.items,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialData_DailyTrialReward.descriptor = new DailyTrialData_DailyTrialReward_Descriptor();
class DailyTrialData_DailyTrialChest {
  get descriptor() {
    return DailyTrialData_DailyTrialChest.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasChest = false;
    this._chest = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasChest && !this._chest.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialData_DailyTrialChest) {
      return value;
    }
    return DailyTrialData_DailyTrialChest.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialData_DailyTrialChest();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.chest != null) {
      result._hasChest = true;
      result._chest = dcei_wildsky_chest_proto.Chest.fromJson(json.chest);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasChest && !this._chest.isEmpty()) {
      result.chest = dcei_wildsky_chest_proto.Chest.toJson(this._chest);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {dcei_wildsky_chest_proto.Chest}
   */
  get chest() {
    return this._hasChest ? this._chest : dcei_wildsky_chest_proto.Chest.default;
  }
  get hasChest() {
    return this._hasChest;
  }
  setChest(path, value) {
    return {type: 'SET', path: path.concat(['chest']), value: value.toJson()};
  }
  deleteChest(path) {
    return {type: 'DELETE', path: path.concat(['chest'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_DailyTrialChest(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new DailyTrialData_DailyTrialChest(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "chest": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData_DailyTrialChest(this);
              copy._hasChest = true;
              copy._chest = dcei_wildsky_chest_proto.Chest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChest) {
                return this;
              }
              const copy = new DailyTrialData_DailyTrialChest(this);
              copy._hasChest = false;
              copy._chest = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChest) {
            const copy = new DailyTrialData_DailyTrialChest(this);
            copy._hasChest = true;
            copy._chest = dcei_wildsky_chest_proto.Chest.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chest.apply(type, path.slice(1), value);
          if (newValue === this._chest) {
            return this;
          }
          const copy = new DailyTrialData_DailyTrialChest(this);
          copy._chest = copy._chest.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialData_DailyTrialChest} other
   * @returns {DailyTrialData_DailyTrialChest}
   */
  merge(other) {
    const copy = new DailyTrialData_DailyTrialChest(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasChest) {
      if (copy._hasChest) {
        copy._chest = copy.chest.merge(other.chest);
      } else {
        copy._chest = other._chest;
      }
      copy._hasChest = true;
    }
    return copy;
  }
}
DailyTrialData_DailyTrialChest.default = new DailyTrialData_DailyTrialChest();
class DailyTrialData_DailyTrialChest_Builder {
  constructor(value) {
    this._value = new DailyTrialData_DailyTrialChest(value);
  }
  build() {
    return new DailyTrialData_DailyTrialChest(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setChest(value) {
    this._value._hasChest = true;
    this._value._chest = value;
    return this;
  }
  deleteChest() {
    this._value._hasChest = false;
    this._value._chest = null;
    return this;
  }
}
DailyTrialData_DailyTrialChest.Builder = DailyTrialData_DailyTrialChest_Builder;
class DailyTrialData_DailyTrialChest_WithParent {
  /**
   * @param {DailyTrialData_DailyTrialChest} value
   * @param {DailyTrialData_DailyTrialChest_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialData_DailyTrialChest.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasChest() {
    if (this._cachedHasChest === undefined) {
      if (this._value.hasChest) {
        this._cachedHasChest = true;
      } else {
        this._cachedHasChest = this._parent ? this._parent.hasChest : false;
      }
    }
    return this._cachedHasChest;
  }
  get chest() {
    if (!this._cachedChest) {
      if (this._value.hasChest) {
        this._cachedChest = new dcei_wildsky_chest_proto.Chest.WithParent(this._value.chest, this._parent && this._parent.hasChest ? this._parent.chest : null);
      } else {
        this._cachedChest = this._parent ? new dcei_wildsky_chest_proto.Chest.WithParent(dcei_wildsky_chest_proto.Chest.default, this._parent.chest) : dcei_wildsky_chest_proto.Chest.WithParent.default;
      }
    }
    return this._cachedChest;
  }
  update(current, parent) {
    const result = new DailyTrialData_DailyTrialChest_WithParent(current, parent);
    if (this._cachedChest && this._value.hasChest && current.hasChest) {
      if (this._value.chest === current.chest && this._parent === parent) {
        result._cachedChest = this._cachedChest;
      } else {
        result._cachedChest = this._cachedChest.update(current.chest, parent && parent.hasChest ? parent.chest : null);
      }
    }
    return result;
  }
}
DailyTrialData_DailyTrialChest_WithParent.default = new DailyTrialData_DailyTrialChest_WithParent(DailyTrialData_DailyTrialChest.default, null);
DailyTrialData_DailyTrialChest.WithParent = DailyTrialData_DailyTrialChest_WithParent;
class DailyTrialData_DailyTrialChest_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get chest() {
    if (!this._chest) {
      this._chest = {
        name: "chest",
        Name: "Chest",
        number: 2,
        protoType: 11,
        protoName: "chest",
        type: dcei_wildsky_chest_proto.Chest,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chest;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.chest,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChest",
        Name: "DummyOneofForChest",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialData_DailyTrialChest.descriptor = new DailyTrialData_DailyTrialChest_Descriptor();
export class DailyTrialData {
  get descriptor() {
    return DailyTrialData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasResetTimeInSeconds = false;
    this._resetTimeInSeconds = null;
    this._levels = [];
    this._rewards = [];
    this._chests = [];
  }
  isEmpty() {
    if (this._hasResetTimeInSeconds) return false;
    if (this._levels.length > 0) return false;
    if (this._rewards.length > 0) return false;
    if (this._chests.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialData) {
      return value;
    }
    return DailyTrialData.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialData();
    if (json.resetTimeInSeconds != null) {
      result._hasResetTimeInSeconds = true;
      result._resetTimeInSeconds = JsonToInt32.fromJson(json.resetTimeInSeconds);
    }
    result._levels = JsonToList(json.levels, DailyTrialData_Level);
    result._rewards = JsonToList(json.rewards, DailyTrialData_DailyTrialReward);
    result._chests = JsonToList(json.chests, DailyTrialData_DailyTrialChest);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasResetTimeInSeconds) {
      result.resetTimeInSeconds = JsonToInt32.toJson(this._resetTimeInSeconds);
    }
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, DailyTrialData_Level);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, DailyTrialData_DailyTrialReward);
    }
    if (this._chests.length > 0) {
      result.chests = ArrayToJson(this._chests, DailyTrialData_DailyTrialChest);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get resetTimeInSeconds() {
    return this._hasResetTimeInSeconds ? this._resetTimeInSeconds : JsonToInt32.default;
  }
  get hasResetTimeInSeconds() {
    return this._hasResetTimeInSeconds;
  }
  setResetTimeInSeconds(path, value) {
    return {type: 'SET', path: path.concat(['resetTimeInSeconds']), value};
  }
  deleteResetTimeInSeconds(path) {
    return {type: 'DELETE', path: path.concat(['resetTimeInSeconds'])};
  }
  /**
   * @returns {DailyTrialData_Level[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, DailyTrialData_Level)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  /**
   * @returns {DailyTrialData_DailyTrialReward[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, DailyTrialData_DailyTrialReward)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  /**
   * @returns {DailyTrialData_DailyTrialChest[]}
   */
  get chests() {
    return this._chests;
  }
  addChests(path, value) {
    return {type: 'ADD', path: path.concat(['chests']), value: value.toJson()};
  }
  setChests(path, value) {
    return {type: 'SET', path: path.concat(['chests']), value: ArrayToJson(value, DailyTrialData_DailyTrialChest)};
  }
  setChestsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['chests', key]), value: value.toJson()};
  }
  deleteChests(path) {
    return {type: 'DELETE', path: path.concat(['chests'])};
  }
  deleteChestsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['chests', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "resetTimeInSeconds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._hasResetTimeInSeconds = true;
              copy._resetTimeInSeconds = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasResetTimeInSeconds) {
                return this;
              }
              const copy = new DailyTrialData(this);
              copy._hasResetTimeInSeconds = false;
              copy._resetTimeInSeconds = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(DailyTrialData_Level.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialData(this);
              copy._levels = copy._levels.concat([DailyTrialData_Level.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new DailyTrialData(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = DailyTrialData_Level.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialData(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialData(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(DailyTrialData_DailyTrialReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialData(this);
              copy._rewards = copy._rewards.concat([DailyTrialData_DailyTrialReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new DailyTrialData(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = DailyTrialData_DailyTrialReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialData(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialData(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      case "chests": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._chests = [];        for (let i of value) {
                copy._chests.push(DailyTrialData_DailyTrialChest.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialData(this);
              copy._chests = copy._chests.concat([DailyTrialData_DailyTrialChest.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._chests.length === 0) {
                return this;
              }
              const copy = new DailyTrialData(this);
              copy._chests = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._chests.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialData(this);
              copy._chests = copy._chests.slice();
              copy._chests[path[1]] = DailyTrialData_DailyTrialChest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialData(this);
              copy._chests = copy._chests.slice(0, path[1]).concat(copy._chests.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._chests.length) {
            return this;
          }
          const oldValue = this._chests[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialData(this);
          copy._chests = copy._chests.slice();
          copy._chests[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialData} other
   * @returns {DailyTrialData}
   */
  merge(other) {
    const copy = new DailyTrialData(this);
    if (other._hasResetTimeInSeconds) {
      copy._hasResetTimeInSeconds = true;
      copy._resetTimeInSeconds = other._resetTimeInSeconds;
    }
    copy._levels = this._levels.concat(other._levels);
    copy._rewards = this._rewards.concat(other._rewards);
    copy._chests = this._chests.concat(other._chests);
    return copy;
  }
}
DailyTrialData.default = new DailyTrialData();
DailyTrialData.Level = DailyTrialData_Level;
DailyTrialData.DailyTrialReward = DailyTrialData_DailyTrialReward;
DailyTrialData.DailyTrialChest = DailyTrialData_DailyTrialChest;
class DailyTrialData_Builder {
  constructor(value) {
    this._value = new DailyTrialData(value);
  }
  build() {
    return new DailyTrialData(this._value);
  }
  setResetTimeInSeconds(value) {
    this._value._hasResetTimeInSeconds = true;
    this._value._resetTimeInSeconds = value;
    return this;
  }
  deleteResetTimeInSeconds() {
    this._value._hasResetTimeInSeconds = false;
    this._value._resetTimeInSeconds = null;
    return this;
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
  addAllChests(values) {
    this._value._chests = this._value._chests.concat(values);
    return this;
  }
  addChests(value) {
    this._value._chests = this._value._chests.concat([value]);
    return this;
  }
  setChests(index, value) {
    this._value._chests = this._value._chests.concat();
    this._value._chests[index] = value;
    return this;
  }
  clearChests() {
    this._value._chests = [];
    return this;
  }
}
DailyTrialData.Builder = DailyTrialData_Builder;
class DailyTrialData_WithParent {
  /**
   * @param {DailyTrialData} value
   * @param {DailyTrialData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasResetTimeInSeconds() {
    if (this._cachedHasResetTimeInSeconds === undefined) {
      if (this._value.hasResetTimeInSeconds) {
        this._cachedHasResetTimeInSeconds = true;
      } else {
        this._cachedHasResetTimeInSeconds = this._parent ? this._parent.hasResetTimeInSeconds : false;
      }
    }
    return this._cachedHasResetTimeInSeconds;
  }
  get resetTimeInSeconds() {
    if (this._cachedResetTimeInSeconds === undefined) {
      if (this._value.hasResetTimeInSeconds) {
        this._cachedResetTimeInSeconds = this._value.resetTimeInSeconds;
      } else {
        this._cachedResetTimeInSeconds = this._parent ? this._parent.resetTimeInSeconds : this._value.resetTimeInSeconds;
      }
    }
    return this._cachedResetTimeInSeconds;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new DailyTrialData_Level.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new DailyTrialData_DailyTrialReward.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  get selfChests() {
    if (!this._selfChests) {
      this._selfChests = [];
      for (let i of this._value.chests) {
        this._selfChests.push(new DailyTrialData_DailyTrialChest.WithParent(i, null));
      }
    }
    return this._selfChests;
  }
  get inherentChests() {
    if (!this._inherentChests) {
      this._inherentChests = this._parent ? this._parent.chests : [];
    }
    return this._inherentChests;
  }
  get chests() {
    if (!this._allChests) {
      this._allChests = this._parent ? this._parent.chests.concat(this.selfChests) : this.selfChests;
    }
    return this._allChests;
  }
  update(current, parent) {
    const result = new DailyTrialData_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new DailyTrialData_Level.WithParent(current.levels[i], null);
          }
        }
      }
    }
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new DailyTrialData_DailyTrialReward.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    if (this._selfChests) {
      if (this._value.chests === current.chests) {
        result._selfChests = this._selfChests;
      } else {
        result._selfChests = [];
        for (let i = 0; i < current.chests.length; i++) {
          const oldValue = this._value.chests[i];
          if (oldValue) {
            const oldCache = this._selfChests[i];
            if (oldValue === current.chests[i]) {
              result._selfChests[i] = oldCache;
            } else {
              result._selfChests[i] = oldCache.update(current.chests[i], null);
            }
          } else {
            result._selfChests[i] = new DailyTrialData_DailyTrialChest.WithParent(current.chests[i], null);
          }
        }
      }
    }
    return result;
  }
}
DailyTrialData_WithParent.default = new DailyTrialData_WithParent(DailyTrialData.default, null);
DailyTrialData.WithParent = DailyTrialData_WithParent;
class DailyTrialData_Descriptor {
  get resetTimeInSeconds() {
    if (!this._resetTimeInSeconds) {
      this._resetTimeInSeconds = {
        name: "resetTimeInSeconds",
        Name: "ResetTimeInSeconds",
        number: 1,
        protoType: 5,
        protoName: "reset_time_in_seconds",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._resetTimeInSeconds;
  }
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 2,
        protoType: 11,
        protoName: "levels",
        type: DailyTrialData_Level,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 3,
        protoType: 11,
        protoName: "rewards",
        type: DailyTrialData_DailyTrialReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get chests() {
    if (!this._chests) {
      this._chests = {
        name: "chests",
        Name: "Chests",
        number: 4,
        protoType: 11,
        protoName: "chests",
        type: DailyTrialData_DailyTrialChest,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chests;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.resetTimeInSeconds,
        this.levels,
        this.rewards,
        this.chests,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForResetTimeInSeconds",
        Name: "DummyOneofForResetTimeInSeconds",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialData.descriptor = new DailyTrialData_Descriptor();
class DailyTrialStatus_ChestStatus {
  get descriptor() {
    return DailyTrialStatus_ChestStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasCumulativeTenDraw = false;
    this._cumulativeTenDraw = null;
  }
  isEmpty() {
    if (this._hasCumulativeTenDraw) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialStatus_ChestStatus) {
      return value;
    }
    return DailyTrialStatus_ChestStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialStatus_ChestStatus();
    if (json.cumulativeTenDraw != null) {
      result._hasCumulativeTenDraw = true;
      result._cumulativeTenDraw = JsonToInt32.fromJson(json.cumulativeTenDraw);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasCumulativeTenDraw) {
      result.cumulativeTenDraw = JsonToInt32.toJson(this._cumulativeTenDraw);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get cumulativeTenDraw() {
    return this._hasCumulativeTenDraw ? this._cumulativeTenDraw : JsonToInt32.default;
  }
  get hasCumulativeTenDraw() {
    return this._hasCumulativeTenDraw;
  }
  setCumulativeTenDraw(path, value) {
    return {type: 'SET', path: path.concat(['cumulativeTenDraw']), value};
  }
  deleteCumulativeTenDraw(path) {
    return {type: 'DELETE', path: path.concat(['cumulativeTenDraw'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "cumulativeTenDraw": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus_ChestStatus(this);
              copy._hasCumulativeTenDraw = true;
              copy._cumulativeTenDraw = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCumulativeTenDraw) {
                return this;
              }
              const copy = new DailyTrialStatus_ChestStatus(this);
              copy._hasCumulativeTenDraw = false;
              copy._cumulativeTenDraw = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialStatus_ChestStatus} other
   * @returns {DailyTrialStatus_ChestStatus}
   */
  merge(other) {
    const copy = new DailyTrialStatus_ChestStatus(this);
    if (other._hasCumulativeTenDraw) {
      copy._hasCumulativeTenDraw = true;
      copy._cumulativeTenDraw = other._cumulativeTenDraw;
    }
    return copy;
  }
}
DailyTrialStatus_ChestStatus.default = new DailyTrialStatus_ChestStatus();
class DailyTrialStatus_ChestStatus_Builder {
  constructor(value) {
    this._value = new DailyTrialStatus_ChestStatus(value);
  }
  build() {
    return new DailyTrialStatus_ChestStatus(this._value);
  }
  setCumulativeTenDraw(value) {
    this._value._hasCumulativeTenDraw = true;
    this._value._cumulativeTenDraw = value;
    return this;
  }
  deleteCumulativeTenDraw() {
    this._value._hasCumulativeTenDraw = false;
    this._value._cumulativeTenDraw = null;
    return this;
  }
}
DailyTrialStatus_ChestStatus.Builder = DailyTrialStatus_ChestStatus_Builder;
class DailyTrialStatus_ChestStatus_WithParent {
  /**
   * @param {DailyTrialStatus_ChestStatus} value
   * @param {DailyTrialStatus_ChestStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialStatus_ChestStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasCumulativeTenDraw() {
    if (this._cachedHasCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedHasCumulativeTenDraw = true;
      } else {
        this._cachedHasCumulativeTenDraw = this._parent ? this._parent.hasCumulativeTenDraw : false;
      }
    }
    return this._cachedHasCumulativeTenDraw;
  }
  get cumulativeTenDraw() {
    if (this._cachedCumulativeTenDraw === undefined) {
      if (this._value.hasCumulativeTenDraw) {
        this._cachedCumulativeTenDraw = this._value.cumulativeTenDraw;
      } else {
        this._cachedCumulativeTenDraw = this._parent ? this._parent.cumulativeTenDraw : this._value.cumulativeTenDraw;
      }
    }
    return this._cachedCumulativeTenDraw;
  }
  update(current, parent) {
    const result = new DailyTrialStatus_ChestStatus_WithParent(current, parent);
    return result;
  }
}
DailyTrialStatus_ChestStatus_WithParent.default = new DailyTrialStatus_ChestStatus_WithParent(DailyTrialStatus_ChestStatus.default, null);
DailyTrialStatus_ChestStatus.WithParent = DailyTrialStatus_ChestStatus_WithParent;
class DailyTrialStatus_ChestStatus_Descriptor {
  get cumulativeTenDraw() {
    if (!this._cumulativeTenDraw) {
      this._cumulativeTenDraw = {
        name: "cumulativeTenDraw",
        Name: "CumulativeTenDraw",
        number: 1,
        protoType: 5,
        protoName: "cumulative_ten_draw",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cumulativeTenDraw;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.cumulativeTenDraw,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCumulativeTenDraw",
        Name: "DummyOneofForCumulativeTenDraw",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialStatus_ChestStatus.descriptor = new DailyTrialStatus_ChestStatus_Descriptor();
class DailyTrialStatus_LevelStatus {
  get descriptor() {
    return DailyTrialStatus_LevelStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasTrialProgress = false;
    this._trialProgress = null;
    this._hasCompleted = false;
    this._completed = null;
  }
  isEmpty() {
    if (this._hasTrialProgress) return false;
    if (this._hasCompleted) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialStatus_LevelStatus) {
      return value;
    }
    return DailyTrialStatus_LevelStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialStatus_LevelStatus();
    if (json.trialProgress != null) {
      result._hasTrialProgress = true;
      result._trialProgress = JsonToInt32.fromJson(json.trialProgress);
    }
    if (json.completed != null) {
      result._hasCompleted = true;
      result._completed = JsonToBoolean.fromJson(json.completed);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasTrialProgress) {
      result.trialProgress = JsonToInt32.toJson(this._trialProgress);
    }
    if (this._hasCompleted) {
      result.completed = JsonToBoolean.toJson(this._completed);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get trialProgress() {
    return this._hasTrialProgress ? this._trialProgress : JsonToInt32.default;
  }
  get hasTrialProgress() {
    return this._hasTrialProgress;
  }
  setTrialProgress(path, value) {
    return {type: 'SET', path: path.concat(['trialProgress']), value};
  }
  deleteTrialProgress(path) {
    return {type: 'DELETE', path: path.concat(['trialProgress'])};
  }
  /**
   * @returns {boolean}
   */
  get completed() {
    return this._hasCompleted ? this._completed : JsonToBoolean.default;
  }
  get hasCompleted() {
    return this._hasCompleted;
  }
  setCompleted(path, value) {
    return {type: 'SET', path: path.concat(['completed']), value};
  }
  deleteCompleted(path) {
    return {type: 'DELETE', path: path.concat(['completed'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "trialProgress": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus_LevelStatus(this);
              copy._hasTrialProgress = true;
              copy._trialProgress = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTrialProgress) {
                return this;
              }
              const copy = new DailyTrialStatus_LevelStatus(this);
              copy._hasTrialProgress = false;
              copy._trialProgress = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "completed": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus_LevelStatus(this);
              copy._hasCompleted = true;
              copy._completed = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCompleted) {
                return this;
              }
              const copy = new DailyTrialStatus_LevelStatus(this);
              copy._hasCompleted = false;
              copy._completed = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialStatus_LevelStatus} other
   * @returns {DailyTrialStatus_LevelStatus}
   */
  merge(other) {
    const copy = new DailyTrialStatus_LevelStatus(this);
    if (other._hasTrialProgress) {
      copy._hasTrialProgress = true;
      copy._trialProgress = other._trialProgress;
    }
    if (other._hasCompleted) {
      copy._hasCompleted = true;
      copy._completed = other._completed;
    }
    return copy;
  }
}
DailyTrialStatus_LevelStatus.default = new DailyTrialStatus_LevelStatus();
class DailyTrialStatus_LevelStatus_Builder {
  constructor(value) {
    this._value = new DailyTrialStatus_LevelStatus(value);
  }
  build() {
    return new DailyTrialStatus_LevelStatus(this._value);
  }
  setTrialProgress(value) {
    this._value._hasTrialProgress = true;
    this._value._trialProgress = value;
    return this;
  }
  deleteTrialProgress() {
    this._value._hasTrialProgress = false;
    this._value._trialProgress = null;
    return this;
  }
  setCompleted(value) {
    this._value._hasCompleted = true;
    this._value._completed = value;
    return this;
  }
  deleteCompleted() {
    this._value._hasCompleted = false;
    this._value._completed = null;
    return this;
  }
}
DailyTrialStatus_LevelStatus.Builder = DailyTrialStatus_LevelStatus_Builder;
class DailyTrialStatus_LevelStatus_WithParent {
  /**
   * @param {DailyTrialStatus_LevelStatus} value
   * @param {DailyTrialStatus_LevelStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialStatus_LevelStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasTrialProgress() {
    if (this._cachedHasTrialProgress === undefined) {
      if (this._value.hasTrialProgress) {
        this._cachedHasTrialProgress = true;
      } else {
        this._cachedHasTrialProgress = this._parent ? this._parent.hasTrialProgress : false;
      }
    }
    return this._cachedHasTrialProgress;
  }
  get trialProgress() {
    if (this._cachedTrialProgress === undefined) {
      if (this._value.hasTrialProgress) {
        this._cachedTrialProgress = this._value.trialProgress;
      } else {
        this._cachedTrialProgress = this._parent ? this._parent.trialProgress : this._value.trialProgress;
      }
    }
    return this._cachedTrialProgress;
  }
  get hasCompleted() {
    if (this._cachedHasCompleted === undefined) {
      if (this._value.hasCompleted) {
        this._cachedHasCompleted = true;
      } else {
        this._cachedHasCompleted = this._parent ? this._parent.hasCompleted : false;
      }
    }
    return this._cachedHasCompleted;
  }
  get completed() {
    if (this._cachedCompleted === undefined) {
      if (this._value.hasCompleted) {
        this._cachedCompleted = this._value.completed;
      } else {
        this._cachedCompleted = this._parent ? this._parent.completed : this._value.completed;
      }
    }
    return this._cachedCompleted;
  }
  update(current, parent) {
    const result = new DailyTrialStatus_LevelStatus_WithParent(current, parent);
    return result;
  }
}
DailyTrialStatus_LevelStatus_WithParent.default = new DailyTrialStatus_LevelStatus_WithParent(DailyTrialStatus_LevelStatus.default, null);
DailyTrialStatus_LevelStatus.WithParent = DailyTrialStatus_LevelStatus_WithParent;
class DailyTrialStatus_LevelStatus_Descriptor {
  get trialProgress() {
    if (!this._trialProgress) {
      this._trialProgress = {
        name: "trialProgress",
        Name: "TrialProgress",
        number: 1,
        protoType: 5,
        protoName: "trial_progress",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._trialProgress;
  }
  get completed() {
    if (!this._completed) {
      this._completed = {
        name: "completed",
        Name: "Completed",
        number: 2,
        protoType: 8,
        protoName: "completed",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._completed;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.trialProgress,
        this.completed,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForTrialProgress",
        Name: "DummyOneofForTrialProgress",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCompleted",
        Name: "DummyOneofForCompleted",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialStatus_LevelStatus.descriptor = new DailyTrialStatus_LevelStatus_Descriptor();
export class DailyTrialStatus {
  get descriptor() {
    return DailyTrialStatus.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasNextFetchTime = false;
    this._nextFetchTime = null;
    this._hasLevelStatus = false;
    this._levelStatus = null;
    this._hasChestStatus = false;
    this._chestStatus = null;
    this._hasEnabled = false;
    this._enabled = null;
  }
  isEmpty() {
    if (this._hasNextFetchTime) return false;
    if (this._hasLevelStatus && !this._levelStatus.isEmpty()) return false;
    if (this._hasChestStatus && !this._chestStatus.isEmpty()) return false;
    if (this._hasEnabled) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialStatus) {
      return value;
    }
    return DailyTrialStatus.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialStatus();
    if (json.nextFetchTime != null) {
      result._hasNextFetchTime = true;
      result._nextFetchTime = JsonToDouble.fromJson(json.nextFetchTime);
    }
    if (json.levelStatus != null) {
      result._hasLevelStatus = true;
      result._levelStatus = DailyTrialStatus_LevelStatus.fromJson(json.levelStatus);
    }
    if (json.chestStatus != null) {
      result._hasChestStatus = true;
      result._chestStatus = DailyTrialStatus_ChestStatus.fromJson(json.chestStatus);
    }
    if (json.enabled != null) {
      result._hasEnabled = true;
      result._enabled = JsonToBoolean.fromJson(json.enabled);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasNextFetchTime) {
      result.nextFetchTime = JsonToDouble.toJson(this._nextFetchTime);
    }
    if (this._hasLevelStatus && !this._levelStatus.isEmpty()) {
      result.levelStatus = DailyTrialStatus_LevelStatus.toJson(this._levelStatus);
    }
    if (this._hasChestStatus && !this._chestStatus.isEmpty()) {
      result.chestStatus = DailyTrialStatus_ChestStatus.toJson(this._chestStatus);
    }
    if (this._hasEnabled) {
      result.enabled = JsonToBoolean.toJson(this._enabled);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get nextFetchTime() {
    return this._hasNextFetchTime ? this._nextFetchTime : JsonToDouble.default;
  }
  get hasNextFetchTime() {
    return this._hasNextFetchTime;
  }
  setNextFetchTime(path, value) {
    return {type: 'SET', path: path.concat(['nextFetchTime']), value};
  }
  deleteNextFetchTime(path) {
    return {type: 'DELETE', path: path.concat(['nextFetchTime'])};
  }
  /**
   * @returns {DailyTrialStatus_LevelStatus}
   */
  get levelStatus() {
    return this._hasLevelStatus ? this._levelStatus : DailyTrialStatus_LevelStatus.default;
  }
  get hasLevelStatus() {
    return this._hasLevelStatus;
  }
  setLevelStatus(path, value) {
    return {type: 'SET', path: path.concat(['levelStatus']), value: value.toJson()};
  }
  deleteLevelStatus(path) {
    return {type: 'DELETE', path: path.concat(['levelStatus'])};
  }
  /**
   * @returns {DailyTrialStatus_ChestStatus}
   */
  get chestStatus() {
    return this._hasChestStatus ? this._chestStatus : DailyTrialStatus_ChestStatus.default;
  }
  get hasChestStatus() {
    return this._hasChestStatus;
  }
  setChestStatus(path, value) {
    return {type: 'SET', path: path.concat(['chestStatus']), value: value.toJson()};
  }
  deleteChestStatus(path) {
    return {type: 'DELETE', path: path.concat(['chestStatus'])};
  }
  /**
   * @returns {boolean}
   */
  get enabled() {
    return this._hasEnabled ? this._enabled : JsonToBoolean.default;
  }
  get hasEnabled() {
    return this._hasEnabled;
  }
  setEnabled(path, value) {
    return {type: 'SET', path: path.concat(['enabled']), value};
  }
  deleteEnabled(path) {
    return {type: 'DELETE', path: path.concat(['enabled'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "nextFetchTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus(this);
              copy._hasNextFetchTime = true;
              copy._nextFetchTime = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNextFetchTime) {
                return this;
              }
              const copy = new DailyTrialStatus(this);
              copy._hasNextFetchTime = false;
              copy._nextFetchTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus(this);
              copy._hasLevelStatus = true;
              copy._levelStatus = DailyTrialStatus_LevelStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelStatus) {
                return this;
              }
              const copy = new DailyTrialStatus(this);
              copy._hasLevelStatus = false;
              copy._levelStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLevelStatus) {
            const copy = new DailyTrialStatus(this);
            copy._hasLevelStatus = true;
            copy._levelStatus = DailyTrialStatus_LevelStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._levelStatus.apply(type, path.slice(1), value);
          if (newValue === this._levelStatus) {
            return this;
          }
          const copy = new DailyTrialStatus(this);
          copy._levelStatus = copy._levelStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chestStatus": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus(this);
              copy._hasChestStatus = true;
              copy._chestStatus = DailyTrialStatus_ChestStatus.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChestStatus) {
                return this;
              }
              const copy = new DailyTrialStatus(this);
              copy._hasChestStatus = false;
              copy._chestStatus = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChestStatus) {
            const copy = new DailyTrialStatus(this);
            copy._hasChestStatus = true;
            copy._chestStatus = DailyTrialStatus_ChestStatus.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chestStatus.apply(type, path.slice(1), value);
          if (newValue === this._chestStatus) {
            return this;
          }
          const copy = new DailyTrialStatus(this);
          copy._chestStatus = copy._chestStatus.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "enabled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialStatus(this);
              copy._hasEnabled = true;
              copy._enabled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEnabled) {
                return this;
              }
              const copy = new DailyTrialStatus(this);
              copy._hasEnabled = false;
              copy._enabled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialStatus} other
   * @returns {DailyTrialStatus}
   */
  merge(other) {
    const copy = new DailyTrialStatus(this);
    if (other._hasNextFetchTime) {
      copy._hasNextFetchTime = true;
      copy._nextFetchTime = other._nextFetchTime;
    }
    if (other._hasLevelStatus) {
      if (copy._hasLevelStatus) {
        copy._levelStatus = copy.levelStatus.merge(other.levelStatus);
      } else {
        copy._levelStatus = other._levelStatus;
      }
      copy._hasLevelStatus = true;
    }
    if (other._hasChestStatus) {
      if (copy._hasChestStatus) {
        copy._chestStatus = copy.chestStatus.merge(other.chestStatus);
      } else {
        copy._chestStatus = other._chestStatus;
      }
      copy._hasChestStatus = true;
    }
    if (other._hasEnabled) {
      copy._hasEnabled = true;
      copy._enabled = other._enabled;
    }
    return copy;
  }
}
DailyTrialStatus.default = new DailyTrialStatus();
DailyTrialStatus.ChestStatus = DailyTrialStatus_ChestStatus;
DailyTrialStatus.LevelStatus = DailyTrialStatus_LevelStatus;
class DailyTrialStatus_Builder {
  constructor(value) {
    this._value = new DailyTrialStatus(value);
  }
  build() {
    return new DailyTrialStatus(this._value);
  }
  setNextFetchTime(value) {
    this._value._hasNextFetchTime = true;
    this._value._nextFetchTime = value;
    return this;
  }
  deleteNextFetchTime() {
    this._value._hasNextFetchTime = false;
    this._value._nextFetchTime = null;
    return this;
  }
  setLevelStatus(value) {
    this._value._hasLevelStatus = true;
    this._value._levelStatus = value;
    return this;
  }
  deleteLevelStatus() {
    this._value._hasLevelStatus = false;
    this._value._levelStatus = null;
    return this;
  }
  setChestStatus(value) {
    this._value._hasChestStatus = true;
    this._value._chestStatus = value;
    return this;
  }
  deleteChestStatus() {
    this._value._hasChestStatus = false;
    this._value._chestStatus = null;
    return this;
  }
  setEnabled(value) {
    this._value._hasEnabled = true;
    this._value._enabled = value;
    return this;
  }
  deleteEnabled() {
    this._value._hasEnabled = false;
    this._value._enabled = null;
    return this;
  }
}
DailyTrialStatus.Builder = DailyTrialStatus_Builder;
class DailyTrialStatus_WithParent {
  /**
   * @param {DailyTrialStatus} value
   * @param {DailyTrialStatus_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialStatus.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasNextFetchTime() {
    if (this._cachedHasNextFetchTime === undefined) {
      if (this._value.hasNextFetchTime) {
        this._cachedHasNextFetchTime = true;
      } else {
        this._cachedHasNextFetchTime = this._parent ? this._parent.hasNextFetchTime : false;
      }
    }
    return this._cachedHasNextFetchTime;
  }
  get nextFetchTime() {
    if (this._cachedNextFetchTime === undefined) {
      if (this._value.hasNextFetchTime) {
        this._cachedNextFetchTime = this._value.nextFetchTime;
      } else {
        this._cachedNextFetchTime = this._parent ? this._parent.nextFetchTime : this._value.nextFetchTime;
      }
    }
    return this._cachedNextFetchTime;
  }
  get hasLevelStatus() {
    if (this._cachedHasLevelStatus === undefined) {
      if (this._value.hasLevelStatus) {
        this._cachedHasLevelStatus = true;
      } else {
        this._cachedHasLevelStatus = this._parent ? this._parent.hasLevelStatus : false;
      }
    }
    return this._cachedHasLevelStatus;
  }
  get levelStatus() {
    if (!this._cachedLevelStatus) {
      if (this._value.hasLevelStatus) {
        this._cachedLevelStatus = new DailyTrialStatus_LevelStatus.WithParent(this._value.levelStatus, this._parent && this._parent.hasLevelStatus ? this._parent.levelStatus : null);
      } else {
        this._cachedLevelStatus = this._parent ? new DailyTrialStatus_LevelStatus.WithParent(DailyTrialStatus_LevelStatus.default, this._parent.levelStatus) : DailyTrialStatus_LevelStatus.WithParent.default;
      }
    }
    return this._cachedLevelStatus;
  }
  get hasChestStatus() {
    if (this._cachedHasChestStatus === undefined) {
      if (this._value.hasChestStatus) {
        this._cachedHasChestStatus = true;
      } else {
        this._cachedHasChestStatus = this._parent ? this._parent.hasChestStatus : false;
      }
    }
    return this._cachedHasChestStatus;
  }
  get chestStatus() {
    if (!this._cachedChestStatus) {
      if (this._value.hasChestStatus) {
        this._cachedChestStatus = new DailyTrialStatus_ChestStatus.WithParent(this._value.chestStatus, this._parent && this._parent.hasChestStatus ? this._parent.chestStatus : null);
      } else {
        this._cachedChestStatus = this._parent ? new DailyTrialStatus_ChestStatus.WithParent(DailyTrialStatus_ChestStatus.default, this._parent.chestStatus) : DailyTrialStatus_ChestStatus.WithParent.default;
      }
    }
    return this._cachedChestStatus;
  }
  get hasEnabled() {
    if (this._cachedHasEnabled === undefined) {
      if (this._value.hasEnabled) {
        this._cachedHasEnabled = true;
      } else {
        this._cachedHasEnabled = this._parent ? this._parent.hasEnabled : false;
      }
    }
    return this._cachedHasEnabled;
  }
  get enabled() {
    if (this._cachedEnabled === undefined) {
      if (this._value.hasEnabled) {
        this._cachedEnabled = this._value.enabled;
      } else {
        this._cachedEnabled = this._parent ? this._parent.enabled : this._value.enabled;
      }
    }
    return this._cachedEnabled;
  }
  update(current, parent) {
    const result = new DailyTrialStatus_WithParent(current, parent);
    if (this._cachedLevelStatus && this._value.hasLevelStatus && current.hasLevelStatus) {
      if (this._value.levelStatus === current.levelStatus && this._parent === parent) {
        result._cachedLevelStatus = this._cachedLevelStatus;
      } else {
        result._cachedLevelStatus = this._cachedLevelStatus.update(current.levelStatus, parent && parent.hasLevelStatus ? parent.levelStatus : null);
      }
    }
    if (this._cachedChestStatus && this._value.hasChestStatus && current.hasChestStatus) {
      if (this._value.chestStatus === current.chestStatus && this._parent === parent) {
        result._cachedChestStatus = this._cachedChestStatus;
      } else {
        result._cachedChestStatus = this._cachedChestStatus.update(current.chestStatus, parent && parent.hasChestStatus ? parent.chestStatus : null);
      }
    }
    return result;
  }
}
DailyTrialStatus_WithParent.default = new DailyTrialStatus_WithParent(DailyTrialStatus.default, null);
DailyTrialStatus.WithParent = DailyTrialStatus_WithParent;
class DailyTrialStatus_Descriptor {
  get nextFetchTime() {
    if (!this._nextFetchTime) {
      this._nextFetchTime = {
        name: "nextFetchTime",
        Name: "NextFetchTime",
        number: 1,
        protoType: 1,
        protoName: "next_fetch_time",
        type: JsonToDouble,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._nextFetchTime;
  }
  get levelStatus() {
    if (!this._levelStatus) {
      this._levelStatus = {
        name: "levelStatus",
        Name: "LevelStatus",
        number: 2,
        protoType: 11,
        protoName: "level_status",
        type: DailyTrialStatus_LevelStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelStatus;
  }
  get chestStatus() {
    if (!this._chestStatus) {
      this._chestStatus = {
        name: "chestStatus",
        Name: "ChestStatus",
        number: 3,
        protoType: 11,
        protoName: "chest_status",
        type: DailyTrialStatus_ChestStatus,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chestStatus;
  }
  get enabled() {
    if (!this._enabled) {
      this._enabled = {
        name: "enabled",
        Name: "Enabled",
        number: 4,
        protoType: 8,
        protoName: "enabled",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._enabled;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.nextFetchTime,
        this.levelStatus,
        this.chestStatus,
        this.enabled,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForNextFetchTime",
        Name: "DummyOneofForNextFetchTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelStatus",
        Name: "DummyOneofForLevelStatus",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChestStatus",
        Name: "DummyOneofForChestStatus",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEnabled",
        Name: "DummyOneofForEnabled",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialStatus.descriptor = new DailyTrialStatus_Descriptor();
class DailyTrialClientData_Level {
  get descriptor() {
    return DailyTrialClientData_Level.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasDayIndex = false;
    this._dayIndex = null;
    this._hasLevelData = false;
    this._levelData = null;
    this._hasReward = false;
    this._reward = null;
    this._hasChest = false;
    this._chest = null;
    this._hasCreepLevel = false;
    this._creepLevel = null;
  }
  isEmpty() {
    if (this._hasDayIndex) return false;
    if (this._hasLevelData && !this._levelData.isEmpty()) return false;
    if (this._hasReward && !this._reward.isEmpty()) return false;
    if (this._hasChest && !this._chest.isEmpty()) return false;
    if (this._hasCreepLevel) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialClientData_Level) {
      return value;
    }
    return DailyTrialClientData_Level.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialClientData_Level();
    if (json.dayIndex != null) {
      result._hasDayIndex = true;
      result._dayIndex = JsonToInt32.fromJson(json.dayIndex);
    }
    if (json.levelData != null) {
      result._hasLevelData = true;
      result._levelData = DailyTrialData_Level.fromJson(json.levelData);
    }
    if (json.reward != null) {
      result._hasReward = true;
      result._reward = DailyTrialData_DailyTrialReward.fromJson(json.reward);
    }
    if (json.chest != null) {
      result._hasChest = true;
      result._chest = DailyTrialData_DailyTrialChest.fromJson(json.chest);
    }
    if (json.creepLevel != null) {
      result._hasCreepLevel = true;
      result._creepLevel = JsonToInt32.fromJson(json.creepLevel);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasDayIndex) {
      result.dayIndex = JsonToInt32.toJson(this._dayIndex);
    }
    if (this._hasLevelData && !this._levelData.isEmpty()) {
      result.levelData = DailyTrialData_Level.toJson(this._levelData);
    }
    if (this._hasReward && !this._reward.isEmpty()) {
      result.reward = DailyTrialData_DailyTrialReward.toJson(this._reward);
    }
    if (this._hasChest && !this._chest.isEmpty()) {
      result.chest = DailyTrialData_DailyTrialChest.toJson(this._chest);
    }
    if (this._hasCreepLevel) {
      result.creepLevel = JsonToInt32.toJson(this._creepLevel);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get dayIndex() {
    return this._hasDayIndex ? this._dayIndex : JsonToInt32.default;
  }
  get hasDayIndex() {
    return this._hasDayIndex;
  }
  setDayIndex(path, value) {
    return {type: 'SET', path: path.concat(['dayIndex']), value};
  }
  deleteDayIndex(path) {
    return {type: 'DELETE', path: path.concat(['dayIndex'])};
  }
  /**
   * @returns {DailyTrialData_Level}
   */
  get levelData() {
    return this._hasLevelData ? this._levelData : DailyTrialData_Level.default;
  }
  get hasLevelData() {
    return this._hasLevelData;
  }
  setLevelData(path, value) {
    return {type: 'SET', path: path.concat(['levelData']), value: value.toJson()};
  }
  deleteLevelData(path) {
    return {type: 'DELETE', path: path.concat(['levelData'])};
  }
  /**
   * @returns {DailyTrialData_DailyTrialReward}
   */
  get reward() {
    return this._hasReward ? this._reward : DailyTrialData_DailyTrialReward.default;
  }
  get hasReward() {
    return this._hasReward;
  }
  setReward(path, value) {
    return {type: 'SET', path: path.concat(['reward']), value: value.toJson()};
  }
  deleteReward(path) {
    return {type: 'DELETE', path: path.concat(['reward'])};
  }
  /**
   * @returns {DailyTrialData_DailyTrialChest}
   */
  get chest() {
    return this._hasChest ? this._chest : DailyTrialData_DailyTrialChest.default;
  }
  get hasChest() {
    return this._hasChest;
  }
  setChest(path, value) {
    return {type: 'SET', path: path.concat(['chest']), value: value.toJson()};
  }
  deleteChest(path) {
    return {type: 'DELETE', path: path.concat(['chest'])};
  }
  /**
   * @returns {number}
   */
  get creepLevel() {
    return this._hasCreepLevel ? this._creepLevel : JsonToInt32.default;
  }
  get hasCreepLevel() {
    return this._hasCreepLevel;
  }
  setCreepLevel(path, value) {
    return {type: 'SET', path: path.concat(['creepLevel']), value};
  }
  deleteCreepLevel(path) {
    return {type: 'DELETE', path: path.concat(['creepLevel'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "dayIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData_Level(this);
              copy._hasDayIndex = true;
              copy._dayIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDayIndex) {
                return this;
              }
              const copy = new DailyTrialClientData_Level(this);
              copy._hasDayIndex = false;
              copy._dayIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levelData": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData_Level(this);
              copy._hasLevelData = true;
              copy._levelData = DailyTrialData_Level.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevelData) {
                return this;
              }
              const copy = new DailyTrialClientData_Level(this);
              copy._hasLevelData = false;
              copy._levelData = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasLevelData) {
            const copy = new DailyTrialClientData_Level(this);
            copy._hasLevelData = true;
            copy._levelData = DailyTrialData_Level.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._levelData.apply(type, path.slice(1), value);
          if (newValue === this._levelData) {
            return this;
          }
          const copy = new DailyTrialClientData_Level(this);
          copy._levelData = copy._levelData.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "reward": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData_Level(this);
              copy._hasReward = true;
              copy._reward = DailyTrialData_DailyTrialReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReward) {
                return this;
              }
              const copy = new DailyTrialClientData_Level(this);
              copy._hasReward = false;
              copy._reward = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasReward) {
            const copy = new DailyTrialClientData_Level(this);
            copy._hasReward = true;
            copy._reward = DailyTrialData_DailyTrialReward.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._reward.apply(type, path.slice(1), value);
          if (newValue === this._reward) {
            return this;
          }
          const copy = new DailyTrialClientData_Level(this);
          copy._reward = copy._reward.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "chest": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData_Level(this);
              copy._hasChest = true;
              copy._chest = DailyTrialData_DailyTrialChest.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChest) {
                return this;
              }
              const copy = new DailyTrialClientData_Level(this);
              copy._hasChest = false;
              copy._chest = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasChest) {
            const copy = new DailyTrialClientData_Level(this);
            copy._hasChest = true;
            copy._chest = DailyTrialData_DailyTrialChest.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._chest.apply(type, path.slice(1), value);
          if (newValue === this._chest) {
            return this;
          }
          const copy = new DailyTrialClientData_Level(this);
          copy._chest = copy._chest.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "creepLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData_Level(this);
              copy._hasCreepLevel = true;
              copy._creepLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCreepLevel) {
                return this;
              }
              const copy = new DailyTrialClientData_Level(this);
              copy._hasCreepLevel = false;
              copy._creepLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialClientData_Level} other
   * @returns {DailyTrialClientData_Level}
   */
  merge(other) {
    const copy = new DailyTrialClientData_Level(this);
    if (other._hasDayIndex) {
      copy._hasDayIndex = true;
      copy._dayIndex = other._dayIndex;
    }
    if (other._hasLevelData) {
      if (copy._hasLevelData) {
        copy._levelData = copy.levelData.merge(other.levelData);
      } else {
        copy._levelData = other._levelData;
      }
      copy._hasLevelData = true;
    }
    if (other._hasReward) {
      if (copy._hasReward) {
        copy._reward = copy.reward.merge(other.reward);
      } else {
        copy._reward = other._reward;
      }
      copy._hasReward = true;
    }
    if (other._hasChest) {
      if (copy._hasChest) {
        copy._chest = copy.chest.merge(other.chest);
      } else {
        copy._chest = other._chest;
      }
      copy._hasChest = true;
    }
    if (other._hasCreepLevel) {
      copy._hasCreepLevel = true;
      copy._creepLevel = other._creepLevel;
    }
    return copy;
  }
}
DailyTrialClientData_Level.default = new DailyTrialClientData_Level();
class DailyTrialClientData_Level_Builder {
  constructor(value) {
    this._value = new DailyTrialClientData_Level(value);
  }
  build() {
    return new DailyTrialClientData_Level(this._value);
  }
  setDayIndex(value) {
    this._value._hasDayIndex = true;
    this._value._dayIndex = value;
    return this;
  }
  deleteDayIndex() {
    this._value._hasDayIndex = false;
    this._value._dayIndex = null;
    return this;
  }
  setLevelData(value) {
    this._value._hasLevelData = true;
    this._value._levelData = value;
    return this;
  }
  deleteLevelData() {
    this._value._hasLevelData = false;
    this._value._levelData = null;
    return this;
  }
  setReward(value) {
    this._value._hasReward = true;
    this._value._reward = value;
    return this;
  }
  deleteReward() {
    this._value._hasReward = false;
    this._value._reward = null;
    return this;
  }
  setChest(value) {
    this._value._hasChest = true;
    this._value._chest = value;
    return this;
  }
  deleteChest() {
    this._value._hasChest = false;
    this._value._chest = null;
    return this;
  }
  setCreepLevel(value) {
    this._value._hasCreepLevel = true;
    this._value._creepLevel = value;
    return this;
  }
  deleteCreepLevel() {
    this._value._hasCreepLevel = false;
    this._value._creepLevel = null;
    return this;
  }
}
DailyTrialClientData_Level.Builder = DailyTrialClientData_Level_Builder;
class DailyTrialClientData_Level_WithParent {
  /**
   * @param {DailyTrialClientData_Level} value
   * @param {DailyTrialClientData_Level_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialClientData_Level.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasDayIndex() {
    if (this._cachedHasDayIndex === undefined) {
      if (this._value.hasDayIndex) {
        this._cachedHasDayIndex = true;
      } else {
        this._cachedHasDayIndex = this._parent ? this._parent.hasDayIndex : false;
      }
    }
    return this._cachedHasDayIndex;
  }
  get dayIndex() {
    if (this._cachedDayIndex === undefined) {
      if (this._value.hasDayIndex) {
        this._cachedDayIndex = this._value.dayIndex;
      } else {
        this._cachedDayIndex = this._parent ? this._parent.dayIndex : this._value.dayIndex;
      }
    }
    return this._cachedDayIndex;
  }
  get hasLevelData() {
    if (this._cachedHasLevelData === undefined) {
      if (this._value.hasLevelData) {
        this._cachedHasLevelData = true;
      } else {
        this._cachedHasLevelData = this._parent ? this._parent.hasLevelData : false;
      }
    }
    return this._cachedHasLevelData;
  }
  get levelData() {
    if (!this._cachedLevelData) {
      if (this._value.hasLevelData) {
        this._cachedLevelData = new DailyTrialData_Level.WithParent(this._value.levelData, this._parent && this._parent.hasLevelData ? this._parent.levelData : null);
      } else {
        this._cachedLevelData = this._parent ? new DailyTrialData_Level.WithParent(DailyTrialData_Level.default, this._parent.levelData) : DailyTrialData_Level.WithParent.default;
      }
    }
    return this._cachedLevelData;
  }
  get hasReward() {
    if (this._cachedHasReward === undefined) {
      if (this._value.hasReward) {
        this._cachedHasReward = true;
      } else {
        this._cachedHasReward = this._parent ? this._parent.hasReward : false;
      }
    }
    return this._cachedHasReward;
  }
  get reward() {
    if (!this._cachedReward) {
      if (this._value.hasReward) {
        this._cachedReward = new DailyTrialData_DailyTrialReward.WithParent(this._value.reward, this._parent && this._parent.hasReward ? this._parent.reward : null);
      } else {
        this._cachedReward = this._parent ? new DailyTrialData_DailyTrialReward.WithParent(DailyTrialData_DailyTrialReward.default, this._parent.reward) : DailyTrialData_DailyTrialReward.WithParent.default;
      }
    }
    return this._cachedReward;
  }
  get hasChest() {
    if (this._cachedHasChest === undefined) {
      if (this._value.hasChest) {
        this._cachedHasChest = true;
      } else {
        this._cachedHasChest = this._parent ? this._parent.hasChest : false;
      }
    }
    return this._cachedHasChest;
  }
  get chest() {
    if (!this._cachedChest) {
      if (this._value.hasChest) {
        this._cachedChest = new DailyTrialData_DailyTrialChest.WithParent(this._value.chest, this._parent && this._parent.hasChest ? this._parent.chest : null);
      } else {
        this._cachedChest = this._parent ? new DailyTrialData_DailyTrialChest.WithParent(DailyTrialData_DailyTrialChest.default, this._parent.chest) : DailyTrialData_DailyTrialChest.WithParent.default;
      }
    }
    return this._cachedChest;
  }
  get hasCreepLevel() {
    if (this._cachedHasCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedHasCreepLevel = true;
      } else {
        this._cachedHasCreepLevel = this._parent ? this._parent.hasCreepLevel : false;
      }
    }
    return this._cachedHasCreepLevel;
  }
  get creepLevel() {
    if (this._cachedCreepLevel === undefined) {
      if (this._value.hasCreepLevel) {
        this._cachedCreepLevel = this._value.creepLevel;
      } else {
        this._cachedCreepLevel = this._parent ? this._parent.creepLevel : this._value.creepLevel;
      }
    }
    return this._cachedCreepLevel;
  }
  update(current, parent) {
    const result = new DailyTrialClientData_Level_WithParent(current, parent);
    if (this._cachedLevelData && this._value.hasLevelData && current.hasLevelData) {
      if (this._value.levelData === current.levelData && this._parent === parent) {
        result._cachedLevelData = this._cachedLevelData;
      } else {
        result._cachedLevelData = this._cachedLevelData.update(current.levelData, parent && parent.hasLevelData ? parent.levelData : null);
      }
    }
    if (this._cachedReward && this._value.hasReward && current.hasReward) {
      if (this._value.reward === current.reward && this._parent === parent) {
        result._cachedReward = this._cachedReward;
      } else {
        result._cachedReward = this._cachedReward.update(current.reward, parent && parent.hasReward ? parent.reward : null);
      }
    }
    if (this._cachedChest && this._value.hasChest && current.hasChest) {
      if (this._value.chest === current.chest && this._parent === parent) {
        result._cachedChest = this._cachedChest;
      } else {
        result._cachedChest = this._cachedChest.update(current.chest, parent && parent.hasChest ? parent.chest : null);
      }
    }
    return result;
  }
}
DailyTrialClientData_Level_WithParent.default = new DailyTrialClientData_Level_WithParent(DailyTrialClientData_Level.default, null);
DailyTrialClientData_Level.WithParent = DailyTrialClientData_Level_WithParent;
class DailyTrialClientData_Level_Descriptor {
  get dayIndex() {
    if (!this._dayIndex) {
      this._dayIndex = {
        name: "dayIndex",
        Name: "DayIndex",
        number: 1,
        protoType: 5,
        protoName: "day_index",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dayIndex;
  }
  get levelData() {
    if (!this._levelData) {
      this._levelData = {
        name: "levelData",
        Name: "LevelData",
        number: 2,
        protoType: 11,
        protoName: "level_data",
        type: DailyTrialData_Level,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levelData;
  }
  get reward() {
    if (!this._reward) {
      this._reward = {
        name: "reward",
        Name: "Reward",
        number: 3,
        protoType: 11,
        protoName: "reward",
        type: DailyTrialData_DailyTrialReward,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reward;
  }
  get chest() {
    if (!this._chest) {
      this._chest = {
        name: "chest",
        Name: "Chest",
        number: 4,
        protoType: 11,
        protoName: "chest",
        type: DailyTrialData_DailyTrialChest,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chest;
  }
  get creepLevel() {
    if (!this._creepLevel) {
      this._creepLevel = {
        name: "creepLevel",
        Name: "CreepLevel",
        number: 5,
        protoType: 5,
        protoName: "creep_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._creepLevel;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.dayIndex,
        this.levelData,
        this.reward,
        this.chest,
        this.creepLevel,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForDayIndex",
        Name: "DummyOneofForDayIndex",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevelData",
        Name: "DummyOneofForLevelData",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReward",
        Name: "DummyOneofForReward",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChest",
        Name: "DummyOneofForChest",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCreepLevel",
        Name: "DummyOneofForCreepLevel",
        fields: [
          this.fields[4],
        ],
      });
    }
    return this._oneofs;
  }
}
DailyTrialClientData_Level.descriptor = new DailyTrialClientData_Level_Descriptor();
export class DailyTrialClientData {
  get descriptor() {
    return DailyTrialClientData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._levels = [];
  }
  isEmpty() {
    if (this._levels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof DailyTrialClientData) {
      return value;
    }
    return DailyTrialClientData.fromJson(value);
  }
  static fromJson(json) {
    const result = new DailyTrialClientData();
    result._levels = JsonToList(json.levels, DailyTrialClientData_Level);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, DailyTrialClientData_Level);
    }
    return result;
  }
  /**
   * @returns {DailyTrialClientData_Level[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, DailyTrialClientData_Level)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(DailyTrialClientData_Level.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new DailyTrialClientData(this);
              copy._levels = copy._levels.concat([DailyTrialClientData_Level.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new DailyTrialClientData(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new DailyTrialClientData(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = DailyTrialClientData_Level.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new DailyTrialClientData(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new DailyTrialClientData(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {DailyTrialClientData} other
   * @returns {DailyTrialClientData}
   */
  merge(other) {
    const copy = new DailyTrialClientData(this);
    copy._levels = this._levels.concat(other._levels);
    return copy;
  }
}
DailyTrialClientData.default = new DailyTrialClientData();
DailyTrialClientData.Level = DailyTrialClientData_Level;
class DailyTrialClientData_Builder {
  constructor(value) {
    this._value = new DailyTrialClientData(value);
  }
  build() {
    return new DailyTrialClientData(this._value);
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
}
DailyTrialClientData.Builder = DailyTrialClientData_Builder;
class DailyTrialClientData_WithParent {
  /**
   * @param {DailyTrialClientData} value
   * @param {DailyTrialClientData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return DailyTrialClientData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new DailyTrialClientData_Level.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  update(current, parent) {
    const result = new DailyTrialClientData_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new DailyTrialClientData_Level.WithParent(current.levels[i], null);
          }
        }
      }
    }
    return result;
  }
}
DailyTrialClientData_WithParent.default = new DailyTrialClientData_WithParent(DailyTrialClientData.default, null);
DailyTrialClientData.WithParent = DailyTrialClientData_WithParent;
class DailyTrialClientData_Descriptor {
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 1,
        protoType: 11,
        protoName: "levels",
        type: DailyTrialClientData_Level,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.levels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
DailyTrialClientData.descriptor = new DailyTrialClientData_Descriptor();
